import { PARENTEDU_OPTIONS } from '@myap/metadata';
import { SelectField } from '../../forms/FormikFields';
import { FIELD_PARENT1, FIELD_PARENT2, REQUIRED_STUDENT_VALUES } from '../constants';
function ChooseParentalEducation(_ref) {
  var disabled = _ref.disabled,
    isCurrentYear = _ref.isCurrentYear,
    setFieldValue = _ref.setFieldValue;
  if (isCurrentYear) {
    return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      className: disabled ? 'cb-text-disabled' : ''
    }, "Parental Education Level"), /*#__PURE__*/React.createElement("div", {
      className: "cb-spacerv-24"
    }), /*#__PURE__*/React.createElement("p", {
      className: disabled ? 'cb-text-disabled' : ''
    }, /*#__PURE__*/React.createElement("strong", null, "Please indicate your parent or guardian's highest level of education."), /*#__PURE__*/React.createElement("br", null), "(If you have two parents/guardians, describe the level of education for both.)"), /*#__PURE__*/React.createElement(SelectField, {
      label: "Parent or guardian 1",
      emptylabel: "Make a selection",
      name: FIELD_PARENT1,
      options: PARENTEDU_OPTIONS,
      required: REQUIRED_STUDENT_VALUES[FIELD_PARENT1],
      onChange: function onChange(val) {
        return setFieldValue(FIELD_PARENT1, !Number.isNaN(parseInt(val, 10)) ? parseInt(val, 10) : val);
      },
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-spacerv-24"
    }), /*#__PURE__*/React.createElement(SelectField, {
      label: "Parent or guardian 2",
      emptylabel: "Make a selection",
      name: FIELD_PARENT2,
      options: PARENTEDU_OPTIONS,
      required: REQUIRED_STUDENT_VALUES[FIELD_PARENT2],
      onChange: function onChange(val) {
        return setFieldValue(FIELD_PARENT2, !Number.isNaN(parseInt(val, 10)) ? parseInt(val, 10) : val);
      },
      disabled: disabled
    }));
  }
  return null;
}
export default ChooseParentalEducation;